import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "content"]

  toggle() {
    if (this.checkboxTarget.checked) {
      this.contentTarget.classList.remove("hidden")
    } else {
      this.contentTarget.classList.add("hidden")
    }
  }
}
